import React from 'react';

const AssinaturaPendente = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white shadow-xl rounded-lg p-8 w-full max-w-md text-center">
        <h1 className="text-2xl md:text-3xl font-extrabold text-red-600 mb-4">
          Assinatura Suspensa
        </h1>
        <p className="mb-6 text-gray-700">
          Sua assinatura foi suspensa por falta de pagamento.
          <br />
          Para continuar usando a plataforma, regularize seu pagamento.
        </p>
        <a
          href="/confirmar-assinatura"
          className="inline-block bg-green-600 text-white font-semibold px-6 py-3 rounded-full hover:bg-green-700 transition"
        >
          Regularizar Pagamento
        </a>
        <p className="mt-6 text-sm text-gray-600">
          Precisa de ajuda? Entre em contato com nosso suporte:
          <br />
          <a
            href="mailto:contato@elion.com.br"
            className="text-blue-600 hover:underline"
          >
            contato@elion.com.br
          </a>
        </p>
      </div>
    </div>
  );
};

export default AssinaturaPendente;
